import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const SUPPORTED = [
  'ca', 'cs', 'da', 'de', 'el', 'en', 'es', 'fi', 'fr', 'hu',
  'it', 'nl', 'no', 'pl', 'pt', 'ro', 'ru', 'sv', 'uk',
];

function loadLocale(code) {
  try {
    return require(`./locales/${code}.json`);
  } catch {
    return require('./locales/en.json');
  }
}

const messages = {};
SUPPORTED.forEach((code) => {
  messages[code] = loadLocale(code);
});

export { SUPPORTED };

export function detectBrowserLocale() {
  if (typeof navigator === 'undefined') return 'en';
  const lang = (navigator.language || 'en').slice(0, 2).toLowerCase();
  return SUPPORTED.includes(lang) ? lang : 'en';
}

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  silentFallbackWarn: true,
});
